import {
  type GenerateStyle,
  type FullToken,
  genComponentStyleHook,
} from "antd/es/theme/internal";
import { inputPrefixCls } from "@/base/components/input/Input.component";
import { ICON_PREFIX, THEME_PREFIX } from "@/base/constant";

const genStyle: GenerateStyle<FullToken<"Input">> = (token: any) => {
  const {
    controlHeight,
    controlHeightLG,
    iconSize,
    searchButtonColor,
    colorText,
    activeBg,
    colorBorder,
    hoverBorderColor,
    colorBgContainerDisabled,
    inputFontSize,
    inputFontSizeLG,
    inputFontSizeSM,
    controlHeightSM,
  } = token;
  return {
    [`.${inputPrefixCls}`]: {
      minHeight: controlHeight,
      fontSize: inputFontSize,
      [`&:not(textarea)`]: {
        maxHeight: controlHeight,
      },

      [`&-lg`]: {
        minHeight: controlHeightLG,
        fontSize: inputFontSizeLG,
        [`&:not(textarea)`]: {
          maxHeight: controlHeightLG,
        },
      },

      [`&-sm`]: {
        minHeight: controlHeightSM,
        fontSize: inputFontSizeSM,
        [`&:not(textarea)`]: {
          maxHeight: controlHeightSM,
        },
      },

      [`.${ICON_PREFIX}`]: {
        fontSize: iconSize,
      },
    },

    [`.${THEME_PREFIX}`]: {
      [`.${inputPrefixCls}-outlined.${inputPrefixCls}-disabled`]: {
        borderColor: `${colorBorder} !important`,
      },

      [`&.${inputPrefixCls}-affix-wrapper`]: {
        minHeight: controlHeight,
        maxHeight: controlHeight,

        [`&-lg`]: {
          minHeight: controlHeightLG,
          maxHeight: controlHeightLG,
        },

        [`&-sm`]: {
          minHeight: controlHeightSM,
          maxHeight: controlHeightSM,
        },

        [`.${inputPrefixCls}`]: {
          minHeight: `auto !important`,
        },

        [`.${ICON_PREFIX}`]: {
          fontSize: iconSize,

          [`&.${inputPrefixCls}-password-icon`]: {
            color: colorText,
          },
        },
      },

      [`&.${inputPrefixCls}-search-with-button`]: {
        [`.${inputPrefixCls}`]: {
          borderInlineEndWidth: `0 !important`,
        },

        [`
                    .${inputPrefixCls}:not([disabled]):hover + .${inputPrefixCls}-group-addon .${inputPrefixCls}-search-button,
                    .${inputPrefixCls}:not([disabled]):focus + .${inputPrefixCls}-group-addon .${inputPrefixCls}-search-button
                `]: {
          borderBlockColor: `${hoverBorderColor} !important`,
          [`&:last-child`]: {
            borderInlineEndColor: `${hoverBorderColor} !important`,
          },
        },

        [`.${inputPrefixCls}[disabled] + .${inputPrefixCls}-group-addon .${inputPrefixCls}-search-button`]:
          {
            background: `${colorBgContainerDisabled} !important`,
          },

        [`.${inputPrefixCls}-group-addon`]: {
          [`.${inputPrefixCls}-search-button`]: {
            padding: "12px",
            background: `${activeBg}`,
            borderBlockColor: colorBorder,
            borderInlineStartWidth: `0 !important`,

            [`&:hover`]: {
              background: `${activeBg}`,
            },

            [`&:last-child`]: {
              borderInlineEndColor: colorBorder,
            },

            [`.${ICON_PREFIX}`]: {
              color: searchButtonColor,
              fontSize: iconSize,
            },
          },
        },
      },
    },
  };
};

export const useInputStyle = genComponentStyleHook(
  ["Input", "cso"],
  (token) => {
    return [genStyle(token)];
  },
);
